import { useMemo } from "react";

import { useEmbedParametersContext } from "../contexts/embedParametersContext";
import { snowplowAnalyticsExists } from "../helpers/analyticsHelpers";
import { usePlayerStore } from "../store/usePlayerStore";

export const useSnowplowEnabled = () => {
  const { getState } = usePlayerStore();
  const embedParams = useEmbedParametersContext();

  return useMemo(() => {
    return (
      snowplowAnalyticsExists() &&
      __SNOWPLOW_ENABLED &&
      embedParams.analytics &&
      !getState().isCasting
    );
  }, [embedParams, getState]);
};
